import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
import axios from "axios";
import { useTranslation } from "react-i18next";

const SearchBarCarnivals = ({ onSearchResults, setLoading, viewMode }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();

  const handleSearch = async (e) => {
    e?.preventDefault();

    if (!searchTerm.trim()) {
      // If search is empty, reset to normal view
      onSearchResults(null);
      return;
    }

    setIsSearching(true);
    setLoading(true); // Set parent loading state

    try {
      const response = await axios.get(
        `${apiUrl}opportunities/api/carnivals/search/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          params: {
            search: searchTerm,
            is_archived: viewMode === "archived",
          },
        }
      );

      const results = response.data.results || [];
      onSearchResults(results); // Send results to parent
    } catch (error) {
      console.error("Error searching carnivals:", error);
      onSearchResults([]); // Send empty array on error
    } finally {
      setIsSearching(false);
      // Don't set parent loading to false here - let parent component do it when it processes results
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    onSearchResults(null);
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSearch}
      elevation={1}
      sx={{
        p: 1,
        display: "flex",
        alignItems: "center",
        mb: 3,
        borderRadius: 2,
        bgcolor: "#ffffff",
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder={t("carnivals.searchCaravans")}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "transparent",
            },
            "&:hover fieldset": {
              borderColor: "transparent",
            },
            "&.Mui-focused fieldset": {
              borderColor: "transparent",
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="primary" />
            </InputAdornment>
          ),
          endAdornment: searchTerm && (
            <InputAdornment position="end">
              <Button onClick={handleClear} sx={{ minWidth: "auto", p: 0.5 }}>
                <Clear fontSize="small" />
              </Button>
            </InputAdornment>
          ),
        }}
      />
      <Button
        type="button"
        variant="contained"
        onClick={handleSearch}
        disabled={isSearching}
        sx={{
          ml: 1,
          px: 3,
          py: 1,
          bgcolor: "#2563eb",
          "&:hover": {
            bgcolor: "#1d4ed8",
          },
          borderRadius: 1,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        {isSearching ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          t("carnivals.search")
        )}
      </Button>
    </Paper>
  );
};

export default SearchBarCarnivals;
